import ApprovalService from '@/services/approval.service'
import { ApprovalTypes } from '@/common/types'
import { FormStatus } from '@/common'

const validateMoveToPendingOwnerDecisionMixin = {
  data() {
    return {
      allApprovals: []
    }
  },
  computed: {
    canMoveToPendingOwnerDecision() {
      if (
        this.moc.status.value !== FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value &&
        this.moc.status.value !== FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value
      ) {
        return false
      }

      const owner = this.moc.roles.owner
      if (!owner) return false

      // if there are no approvers on the form then no point on moving forward
      let onFormApproversCount = this.moc.roles.approvers
        ? this.moc.roles.approvers.filter(a => {
            return a.id !== this.moc.roles.owner.id
          }).length
        : 0
      let onFormAdditionalApproversCount = this.moc.roles.additionalApprovers
        ? this.moc.roles.additionalApprovers.filter(a => {
            return a.id !== this.moc.roles.owner.id
          }).length
        : 0

      if (onFormApproversCount + onFormAdditionalApproversCount === 0) {
        // we are in an invalid state
        return false
      }

      const approvals = this.allApprovals.filter(d => d.decisionPass === this.moc.multiPassCurrentPass && d.user.id !== owner.id)
      const approvalProcessType = this.moc.approvalProcessType
      const rejectionCount = approvals.filter(a => a.decision.key === 'rejected').length
      const approvalCount = approvals.filter(a => a.decision.key === 'approved').length
      const requiredNonResponders = approvals.filter(a => a.user.required && (!a.decision.key && a.decision.key != null)).length
      let approversCount = 0

      if (approvals.length > 0 && approvalProcessType) {
        if (this.moc.multiPassCurrentPass > 0) {
          const currentPass = approvalProcessType.multiPass.approvalPasses[this.moc.multiPassCurrentPass - 1]
          approversCount =
            (currentPass.approvers || []).filter(a => a.id !== owner.id).length +
            (currentPass.additionalApprovers || []).filter(a => a.id !== owner.id).length
        } else {
          approversCount =
            (this.moc.roles.approvers || []).filter(a => a.id !== owner.id).length +
            (this.moc.roles.additionalApprovers || []).filter(a => a.id !== owner.id).length
        }
        if (approvalCount === approversCount) {
          return true
        }
        switch (approvalProcessType.approvalType) {
          case ApprovalTypes.properties[ApprovalTypes.ALLAPPROVERSMUSTAPPROVE].key:
            // do nothing, if all approvers approved, it's true anyway
            break
          case ApprovalTypes.properties[ApprovalTypes.NOOWNERDECISIONWITHREJECTS].key: {
            if (requiredNonResponders === 0 && rejectionCount === 0 && approvalCount > 0) {
              return true
            }
            break
          }
          case ApprovalTypes.properties[ApprovalTypes.OWNERDECISIONWITHREJECTS].key: {
            if (requiredNonResponders === 0 && approvalCount > 0) {
              return true
            }
            break
          }
        }
      }
      return false
    },
    canOwnerApprove() {
      if (
        this.moc.status.value !== FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value &&
        this.moc.status.value !== FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value
      ) {
        return false
      }

      const owner = this.moc.roles.owner
      if (!owner) return false
      const ownerApproval = this.allApprovals.find(
        d => d.decisionPass === this.moc.multiPassCurrentPass && d.user.id === owner.id
      )

      if (ownerApproval) {
        return (ownerApproval.decision || {}).key !== 'rejected' && this.canMoveToPendingOwnerDecision
      }
      return this.canMoveToPendingOwnerDecision
    }
  },
  mounted() {
    const mocId = this.moc.mocId
    if (
      this.moc.status.value !== FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value &&
      this.moc.status.value !== FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value
    ) {
      return
    }
    ApprovalService.getAllApprovals(this.moc.mocId)
      .then(data => {
        this.allApprovals = data
      })
      .catch(e => {
        console.error(this.$t('Error_GetMOCApprovals_validateMoveToPendingOwnerDecision', { mocId }), e)
      })
  }
}

export default validateMoveToPendingOwnerDecisionMixin
